var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrearFactura(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.2852V3.28516M11 3.28516C11 2.75472 11.2107 2.24602 11.5858 1.87094C11.9609 1.49587 12.4696 1.28516 13 1.28516H20.4C20.4788 1.28516 20.5568 1.30068 20.6296 1.33083C20.7024 1.36098 20.7685 1.40518 20.8243 1.46089C20.88 1.51661 20.9242 1.58275 20.9543 1.65555C20.9845 1.72834 21 1.80636 21 1.88516V14.9992M11 3.28516C11 2.75472 10.7893 2.24602 10.4142 1.87094C10.0391 1.49587 9.53043 1.28516 9 1.28516H1.6C1.44087 1.28516 1.28826 1.34837 1.17574 1.46089C1.06321 1.57341 1 1.72603 1 1.88516V14.9992M13 15.2852H21M9 15.2852H1",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrearFactura);
export default __webpack_public_path__ + "static/media/crear_factura.12a47c4aa96cc16a47e275c1c13a07dc.svg";
export { ForwardRef as ReactComponent };